import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_CARD_ISOMORPHIC_FRAGMENT } from '@/components/NarrativeCard';

const COMPANY_REPORT_NARRATIVE_CARD_FRAGMENT = gql(
  `
  fragment CompanyReportNarrativeCardFields on Narrative @_unmask {
    id
    company {
      id
      uniqueSymbol
    }
    ...NarrativeCardIsomorphicFields
  }
`,
  [NARRATIVE_CARD_ISOMORPHIC_FRAGMENT]
);

const QUERY = gql(
  `
  query SponsoredNarratives($companyId: String!) {
    sponsoredNarratives(companyId: $companyId) {
      ...CompanyReportNarrativeCardFields
    }
  }
`,
  [COMPANY_REPORT_NARRATIVE_CARD_FRAGMENT]
);

export const useSponsoredNarratives = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-company-report-list'],
  staleTime: 0,
});

export type Narrative = FragmentOf<typeof NARRATIVE_CARD_ISOMORPHIC_FRAGMENT>;
